import React from "react"
import macLogo from '../styles/img/logo.png'

/**
 * Header fijo de la aplicación.
 * El modo oscuro se activa cuando <body> tiene la clase "dark"
 * — el CSS lo maneja vía la variable --header-bg definida en header.css.
 */
const Header = () => (
    <header className="app-header">
        <div className="app-header__inner">
            <a href="/" className="app-header__logo-link">
                <img
                    src={macLogo}
                    alt="Hospitales MAC"
                    className="app-header__logo"
                    onError={e => e.target.style.display = 'none'}
                />
            </a>
        </div>
    </header>
)

export default Header